import dynamic from 'next/dynamic';
import { StaticImageData } from 'next/image';
import { useIntl } from 'react-intl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import trailConditionsDaDk from './interstitialImages/trail-conditions-da-DK.avif';
import trailConditionsDeDe from './interstitialImages/trail-conditions-de-DE.avif';
import trailConditionsEnGb from './interstitialImages/trail-conditions-en-GB.avif';
import trailConditionsEnUS from './interstitialImages/trail-conditions-en-US.avif';
import trailConditionsEsEs from './interstitialImages/trail-conditions-es-ES.avif';
import trailConditionsEsMx from './interstitialImages/trail-conditions-es-MX.avif';
import trailConditionsFrFr from './interstitialImages/trail-conditions-fr-FR.avif';
import trailConditionsItIt from './interstitialImages/trail-conditions-it-IT.avif';
import trailConditionsNbNo from './interstitialImages/trail-conditions-nb-NO.avif';
import trailConditionsNlNl from './interstitialImages/trail-conditions-nl-NL.avif';
import trailConditionsPlPl from './interstitialImages/trail-conditions-pl-PL.avif';
import trailConditionsPtBr from './interstitialImages/trail-conditions-pt-BR.avif';
import trailConditionsPtPt from './interstitialImages/trail-conditions-pt-PT.avif';
import trailConditionsSvSE from './interstitialImages/trail-conditions-sv-SE.avif';

const InstallInterstitial = dynamic(() => import('@alltrails/install-prompt/components/InstallInterstitial'), { ssr: false });

const phoneImages: Record<LanguageRegionCode, StaticImageData> = {
  ['da-DK']: trailConditionsDaDk,
  ['nl-NL']: trailConditionsNlNl,
  ['en-GB']: trailConditionsEnGb,
  ['en-US']: trailConditionsEnUS,
  ['fr-FR']: trailConditionsFrFr,
  ['de-DE']: trailConditionsDeDe,
  ['it-IT']: trailConditionsItIt,
  ['nb-NO']: trailConditionsNbNo,
  ['pl-PL']: trailConditionsPlPl,
  ['pt-PT']: trailConditionsPtPt,
  ['pt-BR']: trailConditionsPtBr,
  ['es-ES']: trailConditionsEsEs,
  ['es-MX']: trailConditionsEsMx,
  ['sv-SE']: trailConditionsSvSE
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  trailId: number;
};

export default function TrailConditionsInstallInterstitial({ isOpen, trailId, onRequestClose }: Props) {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <InstallInterstitial
      altText={intl.formatMessage({
        defaultMessage: 'An app screen shows a trail map with multicolored overlay indicating real-time precipitation.'
      })}
      header={intl.formatMessage({ defaultMessage: 'Head to the app for Trail Conditions' })}
      deeplinkData={{ pageId: trailId, pageType: 'trail' }}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      promptLocation="trail page"
      phoneImg={phoneImages[languageRegionCode]}
    />
  );
}
